import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { TokenService } from '../services/token.service';
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class LoginGuard {
  constructor(
    private _token: TokenService,
    private _router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isBusinessPortal = location.pathname.startsWith('/business-portal');
    const navigateTo = isBusinessPortal ? '/business-portal/homepage' : '/';
    const accessToken = isBusinessPortal
      ? this._token.getTokens().businessportalAccessToken
      : this._token.getTokens().accessToken;
    if (accessToken) {
      this._router.navigate([navigateTo]);
      return false;
    } else {
      return true;
    }
  }
}
